import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";

// https://firebase.google.com/docs/web/setup#available-libraries
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
} from "firebase/auth";
import {
  getFirestore,
  query,
  getDocs,
  collection,
  doc,
  where,
  addDoc,
  setDoc,
  getDoc,
  increment
} from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCrhAdYpnUPuRW_oy3JUdXWOieksZqyAxE",
  authDomain: "myratings-ef139.firebaseapp.com",
  projectId: "myratings-ef139",
  storageBucket: "myratings-ef139.appspot.com",
  messagingSenderId: "630577036897",
  appId: "1:630577036897:web:7e50f2844d2e4991167420",
  measurementId: "G-JSRPTF9DNL"
};

const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

const googleProvider = new GoogleAuthProvider();

const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    const q = query(collection(db, "users"), where("uid", "==", user.uid));
    const docs = await getDocs(q);
    if (docs.docs.length === 0) {
      await addDoc(collection(db, "users"), {
        uid: user.uid,
        name: user.displayName,
        authProvider: "google",
        email: user.email,
      });
    }
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logInWithEmailAndPassword = async (e, email, password) => {
  e.preventDefault();
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const registerWithEmailAndPassword = async (e, name, email, password) => {
  e.preventDefault();
  try {
    const res = await createUserWithEmailAndPassword(auth, email, password);
    const user = res.user;
    await addDoc(collection(db, "users"), {
      uid: user.uid,
      name,
      authProvider: "local",
      email,
      credits: 100
    });
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};



const sendPasswordReset = async (e,email) => {
  e.preventDefault();
  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset link sent!");
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logout = () => {
  signOut(auth);
};

const updateAccount = async (e, name, docname) => {
  e.preventDefault();
  try {
    await setDoc(doc(db, "users", docname), {
      name: name
    },{merge: true});
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const rateItem = async (rate,movie,uid,userdocname) => {
  console.log("rating item...");
  console.log(uid);
  console.log(userdocname);
  console.log(auth.currentUser.uid);
  try {
    // check if rating doc already exists or not
    const docRef = doc(db, "ratings", uid+"."+movie.tmdb_id);
    const docSnap = await getDoc(docRef);
     // if not, add 1 to rating counter in user document
    if (!docSnap.exists()) {
      console.log("new rating");
      await setDoc(doc(db, "users", userdocname), {
        ratingCounter: increment(1)
      },{merge: true});
    } 
    else {
      console.log("rating exists already")
    }
   
    // create or update the rating
    await setDoc(doc(db, "ratings", uid+"."+movie.tmdb_id), {
      title: movie.title,
      original_title: movie.original_title,
      type: "movie",
      year: movie.year,
      poster_path: movie.poster_path,
      tmdb_id: movie.tmdb_id,
      rating: parseInt(rate),
      userid: uid,
      updated_at: Date.now()
    },{merge: true});
    window.location.replace("/dashboard");
  } catch (err) {
    console.error(err);
    alert(err.message + "\n userid: " + uid + "\n auth.currentUser.uid: " + auth.currentUser.uid);
  }
}

export {
  auth,
  db,
  signInWithGoogle,
  logInWithEmailAndPassword,
  registerWithEmailAndPassword,
  sendPasswordReset,
  logout,
  updateAccount,
  rateItem
};
